const TIPOS_AUTENTICACION_API = [
  {
    id: 1,
    name: 'Sin autenticación',
  },
  {
    id: 2,
    name: 'Básica',
  },
  {
    id: 3,
    name: 'Token Bearer',
  },
]

export {
  TIPOS_AUTENTICACION_API
}
